import React from "react"
import { 
  MagnifyingGlassIcon, 
  ChevronDownIcon,
  PlusIcon,
  EyeIcon,
  PencilIcon,
  TrashIcon
} from "@heroicons/react/24/outline";
import personImage from './../../assets/images/user.png';

const notifications = [
    {
        id: 1,
        title: 'Offer 20% Off',
        description: '20% off on all purchases',
        users: 232,
        date: "03/08/2023"
    },
    {
        id: 2,
        title: 'Offer 20% Off',
        description: '20% off on all purchases',
        users: 232,
        date: "03/08/2023"
    },
    {
        id: 3,
        title: 'Offer 20% Off',
        description: '20% off on all purchases',
        users: 232,
        date: "03/08/2023"
    },
    {
        id: 4,
        title: 'Offer 20% Off',
        description: '20% off on all purchases',
        users: 232,
        date: "03/08/2023"
    }

  ]
  
  export default function AllNotifications() {
    return (
      <div className="bg-white rounded-[10px] border border-dashboardStroke shadow-[0px_9px_15px_rgba(0,0,0,0.07)] overflow-hidden">
        {/* Dark Header */}
        <div className="bg-dashboardDark h-16 px-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h2 className="text-white font-semibold text-lg">All Notifications</h2>
            <span className="text-white font-semibold">({notifications.length})</span>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 px-3 py-1.5 border border-white rounded">
              <MagnifyingGlassIcon className="w-[18px] h-[18px] text-white" />
              <input
                type="text"
                placeholder="Type to search..."
                className="bg-transparent text-white placeholder-white/70 text-sm font-light outline-none w-28"
              />
            </div>
            
            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>Sort By</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>
            
            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>Date Range</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>
            
            <button className="flex items-center gap-2 px-4 py-1.5 bg-dashboardCoral rounded text-white text-sm font-medium">
              <PlusIcon className="w-[18px] h-[18px]" />
              <span>Add New</span>
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-dashboardStroke">
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Sr#</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Image</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Title</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Description</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Users</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Date</th>
                <th className="px-4 py-4 text-left text-[17px] font-medium text-dashboardText">Actions</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((notification, index) => (
                <tr 
                  key={notification.id}
                  className={`border-b border-dashboardStroke hover:bg-gray-50 transition-colors ${
                    index === 0 ? "shadow-[inset_3px_0px_0px_#FF7C17]" : ""
                  }`}
                >
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {notification.id}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <img src={personImage} alt="Notification" className="h-10 w-10 rounded-full object-cover" />
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-medium text-dashboardCoral">
                    {notification.title}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {notification.description}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {notification.users}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {notification.date}
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center gap-0.5">
                      <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                        <EyeIcon className="w-6 h-6 text-dashboardDark" strokeWidth={1.3} />
                      </button>
                      <div className="w-px h-6 bg-dashboardStroke"></div>
                      <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                        <PencilIcon className="w-6 h-6 text-dashboardDark" strokeWidth={1.3} />
                      </button>
                      <div className="w-px h-6 bg-dashboardStroke"></div>
                      <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                        <TrashIcon className="w-6 h-6 text-dashboardCoral" strokeWidth={1.3} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
  